import loadable from '@loadable/component';

const LoadableQueueModalContainer = loadable(() => import('./queueModalContainer'));

export default LoadableQueueModalContainer;
